import { Tit } from '../Titles';
import IconSearch from '@/assets/img/ico_search@2x.png';
import NullImg1 from '@/assets/img/tmp/no_img1@2x.png';
import NullImg2 from '@/assets/img/tmp/no_img2@2x.png';
import { breakpoint } from '@/helpers/BreakpointHelper';
import styled from 'styled-components';

export const BoardCardLayout = styled.ul`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -16px;
  align-items: stretch;
  margin-top: 32px;

  & > li {
    padding: 0 16px;
    width: 33.33%;
    margin-bottom: 64px;

    ${breakpoint(`tablet`)} {
      width: 50% !important;
    }

    ${breakpoint(`mobile`)} {
      width: 100% !important;
      margin-bottom: 48px;
    }

    .link-item {
      display: block;
      width: 100%;
    }

    .img-wrap {
      position: relative;
      padding-top: 100%;
      height: 0;
      overflow: hidden;
      background: url(${NullImg1}) center no-repeat;
      background-size: cover;

      &::before,
      .img-box {
        display: block;
        position: absolute;
        width: 100%;
        height: 100%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }

      &::before {
        content: '';
        z-index: 1;
        border: 0px solid transparent;
        transition: border 0.2s;
      }
      .img-box {
        width: calc(100% + 2px);
        height: calc(100% + 2px);
        transition-duration: 1.2s;
      }

      &:hover {
        .img-box {
          transform: translate(-50%, -50%) scale(1.2);
        }
        &::before {
          border: 8px solid #1cabe2;
        }
      }
    }

    &:nth-child(2n + 1) {
      .img-wrap {
        background-image: url(${NullImg2});
      }
    }

    .dec-wrap {
      background: #fff;
      padding-top: 32px;

      ${Tit} {
        line-height: 32px;
        height: 64px;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;

        .NewText {
          font-size: 14px;
          color: #1cabe2;
          font-weight: normal;
          display: inline-block;
          margin: -2px 0 0 8px;
          vertical-align: middle;
        }
      }
      .date {
        display: block;
        margin-top: 16px;
      }

      ${breakpoint(`mobile`)} {
        ${Tit} {
          height: auto;
          line-height: 26px;
        }

        .date {
          margin-top: 8px;
        }
      }
    }
  }

  /* 이벤트/캠페이 */
  &.event {
    & > li {
      width: 50%;

      .img-wrap {
        padding-top: 44.12%;
        background-size: 100% auto;

        &::before {
          display: none;
        }
        &:hover {
          .img-box {
            transform: translate(-50%, -50%);
          }
        }
      }

      .dec-wrap {
        padding: 16px;
        padding-bottom: 24px;
      }
    }
  }
`;

export const BoardSearch = styled.div<{ dynamic?: boolean }>`
  width: 100%;
  max-width: 528px;
  display: flex;
  font-size: 0;

  .label-wrap {
    width: calc(100% - 176px);
    position: relative;
    padding-right: 56px;

    button {
      position: absolute;
      right: 0;
      top: 0;
      display: block;
      width: 56px;
      height: 56px;
      border: none;
      background-color: #1cabe2;
      background-image: url(${IconSearch});
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 24px;
    }
  }
  .col-btn {
    width: 176px;
    padding-left: 16px;

    button {
      width: 100%;
      height: 100%;
    }
  }
  ${breakpoint(`tablet`)} {
    max-width: 100%;
  }
  ${breakpoint(`mobile`)} {
    .label-wrap {
      width: calc(100% - 88px);
    }
    .col-btn {
      width: 88px;
      padding-left: 8px;

      button {
        font-size: 14px;
        padding: 0;
      }
    }
  }
`;
